import React from 'react';
import PropTypes from 'prop-types';
import { addYears } from 'date-fns';

import withSearchHandler from 'decorators/withSearchHandler';
import { H1, H2,H3,H4 } from 'components/core/Typography';
import { Group } from 'components/core/Page';
import { IconText } from 'components/core/IconText';
import { SearchBox } from 'components/search/SearchBox';
import { CheckmarkShield, Dollar } from 'components/svg';
import { StickySearchBar } from 'components/landing/StickySearchBar';

import './searchHero.scss';

const withAdditionalSearchParams = (WrappedComponent) => {
	const WithAdditionalSearchParams = (props) => {
		const searchParams = props.searchParams || {};
		const { location, latitude, longitude, ...restSearchParams } =
			searchParams;
		return (
			<WrappedComponent
				{...props}
				additionalSearchParams={restSearchParams}
			/>
		);
	};
	WithAdditionalSearchParams.displayName = `withAdditionalSearchParams(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	return WithAdditionalSearchParams;
};

export const enhance = (Component) =>
	withAdditionalSearchParams(withSearchHandler(Component));

export function SearchHero({
	subheading, headline = 'Find storage units near you.', handleSearch, location, moveInDate, reservationWindow = addYears(new Date(), 1), withValueProps = true, standardHeadlines, isSearchResultsPage
}) {
	return (
		<div className="search-hero">
			<div className="value-props">
				<Group className="headlines">
					{!!headline && !!standardHeadlines &&
						<H1 size="large" className="find-storage" rounded>
							{headline}
						</H1>
					}
					{!!headline && !standardHeadlines &&
						<H2 size="large" className="find-storage" rounded>
							{headline}
						</H2>
					}
					{!!subheading &&
						<H2 size="medium" className="meta-headline">
							{subheading}
						</H2>
					}
				</Group>
				{!!withValueProps &&
					<div className="value-prop-container">
						<div className="value-prop">
							<IconText icon={Dollar} textClassName="value-prop-content">
								<H3 size="small" last>Reserve now, pay later</H3>
							</IconText>
						</div>
						<div className="value-prop">
							<IconText icon={CheckmarkShield} textClassName="value-prop-content">
								<H4 size="small" last>Cancel for free anytime</H4>
							</IconText>
						</div>
					</div>
				}
			</div>
			<SearchBox
				id="hero-sticky-search"
				location={location}
				handleSearch={handleSearch}
				moveInDate={moveInDate}
				reservationWindow={reservationWindow}
			/>
			{ isSearchResultsPage && <StickySearchBar triggerId="hero-sticky-search" handleSearch={handleSearch} />}
		</div>
	);
}

SearchHero.propTypes = {
	subheading: PropTypes.string,
	headline: PropTypes.string,
	location: PropTypes.string,
	moveInDate: PropTypes.instanceOf(Date),
	reservationWindow: PropTypes.instanceOf(Date),
	handleSearch: PropTypes.func,
	withValueProps: PropTypes.bool,
	standardHeadlines: PropTypes.bool
};

export default enhance(SearchHero);
